import { useEffect, useRef, useState } from 'react';

/**
 * Lazy-load hook for below-the-fold images.
 *
 * Strategy (TASK 2 fix): Instead of waiting for IntersectionObserver to fire
 * when the user scrolls, the hook waits for the global `yourngo:loaded` event
 * which App.js dispatches when the loader hits 100% (or 70% video-buffer).
 * That way ALL non-hero images load simultaneously when the site is shown,
 * matching Lumenya/Glow-Pattern. No more "loader at 100% but images missing".
 */
export function useLazyImage(src, options = {}) {
  const { eager = false } = options;
  const imgRef = useRef(null);
  const [loaded, setLoaded] = useState(eager);

  useEffect(() => {
    if (eager || loaded) return;

    // If the yourngo:loaded event already fired (e.g. component mounted late),
    // load immediately instead of waiting forever.
    if (window.__yourngoLoaded === true) {
      setLoaded(true);
      return;
    }

    const onLoaded = () => setLoaded(true);
    window.addEventListener('yourngo:loaded', onLoaded, { once: true });
    return () => window.removeEventListener('yourngo:loaded', onLoaded);
  }, [eager, loaded]);

  return [imgRef, loaded ? src : null];
}

export default useLazyImage;
